module.exports = __webpack_public_path__ + "img/Messages.8e301d93.png";